import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

const API_URL = config.API_URL + '/classement';

class ClassementService {
    getClassement() {
        return axios.get(API_URL, { headers: authHeader() });
    }

    getTopPlayers() {
        return axios.get(API_URL + '/top', { headers: authHeader() });
    }

    getGlobalStats() {
        return axios.get(API_URL + '/stats', { headers: authHeader() });
    }
}

export default new ClassementService(); 